import { Capacitor } from '@capacitor/core';

type WindowDimensions = {
  width: number;
  height: number;
};

export const getWindowDimensions = (): WindowDimensions => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
};

export const isMobileView = (): boolean => {
  const isApp = Capacitor.isNativePlatform();
  const { innerWidth: width } = window;
  const isMobileView = width <= 1024;

  return isApp || isMobileView;
};

export const toggleDarkTheme = (shouldAdd: boolean): void => {
  document.body.classList.toggle('dark', shouldAdd);
};
